<template>
  <div class="block mt-4 py-3 px-4 text-center text-white mb-4" :class="giftCardColor">
    <span class="uppercase small-label">Gift card code</span>
    <div class="uppercase font-bold text-xl">
      {{ code }}
    </div>
    <div class="font-bold text-xl">Gift card value left {{ valueLeft }}</div>
    <div v-if="orders.length > 0 && !giftCardExpired">
      Last used on <strong>{{ formattedUsageDate }}</strong>
    </div>
    <div v-else-if="expiration_date">
      Expires on <strong>{{ formattedExpirationDate }}</strong>
    </div>
  </div>
</template>

<script>
import { format, parseISO, isAfter } from 'date-fns';

export default {
  props: ['code', 'expiration_date', 'orders', 'gift_cards'],
  computed: {
    giftCardColor() {
      if (this.giftCardValue - this.ordersValue === 0 || this.giftCardExpired) {
        return 'bg-gray-600';
      }

      return 'bg-blue-600';
    },
    giftCardExpired() {
      return this.orders.length === 0 && isAfter(new Date(), parseISO(this.expiration_date));
    },
    formattedExpirationDate() {
      if (!this.expiration_date) {
        return null;
      }

      return format(parseISO(this.expiration_date), 'PPP');
    },
    formattedUsageDate() {
      if (this.orders.length === 0) {
        return null;
      }

      return format(parseISO(this.orders.at(-1).order_placed_at), 'PPP');
    },
    giftCardValue() {
      return this.gift_cards.reduce((total, giftCard) => total + giftCard.value_in_cents, 0);
    },
    ordersValue() {
      return this.orders.reduce((total, order) => {
        if (order.vendor_status === 'refunded') {
          return 0;
        }

        return total + order.amount;
      }, 0);
    },
    valueLeft() {
      if (this.ordersValue) {
        return `$${(this.giftCardValue - this.ordersValue) / 100}`;
      }

      return `$${this.giftCardValue / 100}`;
    },
  },
};
</script>
